import { MenuItem } from '@mui/material';
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';

import { QuestionType } from '@/domain/impact/impact.entity';
import { EssQuestion } from '@/domain/impact-ess/entities/question.entity';
import { selectProjectFestivalCurrentAverageCapacity } from '@/domain/project-festival/project-festival.selectors.ts';
import { FSFactorCapacityField } from '@/ui/components/input/FSFactorCapacityField';
import { FSFactorField } from '@/ui/components/input/FSFactorField';
import { FSRadioGroup } from '@/ui/components/input/FSRadioGroup';
import { FSSelect } from '@/ui/components/input/FSSelect';
import { FSSlider } from '@/ui/components/input/FSSlider';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { useAppSelector } from '@/ui/hook/store.ts';
import { language } from '@/ui/i18n';
import { isNumber } from '@/ui/utils/form-validations';

export function DynamicFormInput({
  parameters,
  register,
  control,
  errors,
  onSubmitInput,
}: {
  parameters: EssQuestion; // TODO : check this : should not be ESS only ? right ?
  register: UseFormRegister<FieldValues>;
  control: Control<FieldValues, any>; // eslint-disable-line
  errors: FieldErrors<FieldValues>;
  onSubmitInput: () => void;
}) {
  const avgCapacity = useAppSelector(
    selectProjectFestivalCurrentAverageCapacity,
  );

  switch (parameters.type) {
    case QuestionType.NUMERIC:
      return (
        // text input: submit on blur
        <FSTextField
          type="number"
          register={{
            ...register(parameters.paramId, {
              onBlur: () => onSubmitInput(),
              validate: isNumber,
            }),
          }}
          error={!!errors[parameters.paramId]}
          helperText={errors[parameters.paramId]?.message?.toString()}
        />
      );
    case QuestionType.PERCENT_SLIDER:
      // slider component: submit on change comitted (mouse released the button)
      // slider text: submit on blur (mouse released the button)
      return (
        <FSSlider
          name={parameters.paramId}
          control={control}
          onChangeCommittedSlider={onSubmitInput}
          onBlurNumericField={onSubmitInput}
        />
      );
    case QuestionType.FACTOR:
    case QuestionType.FACTOR_PERCENTAGE:
    case QuestionType.FACTOR_MINISTRY:
    case QuestionType.FRACTION:
    case QuestionType.FACTOR_MINORITY:
      // factor input (text) : submit on blur
      return (
        <FSFactorField
          fields={parameters.fields}
          name={parameters.paramId}
          value={''}
          control={control}
          onBlur={() => onSubmitInput()}
          errors={errors}
        />
      );
    case QuestionType.FACTOR_CAPACITY:
      return (
        <FSFactorCapacityField
          fields={parameters.fields}
          name={parameters.paramId}
          value={''}
          avgCapacity={avgCapacity}
          control={control}
          onBlur={() => onSubmitInput()}
          errors={errors}
        />
      );
    case QuestionType.SELECT:
      // select: submit on change
      return (
        <FSSelect
          control={control}
          name={parameters.paramId}
          onBlur={() => {}}
          onChange={() => onSubmitInput()}
        >
          {parameters.options?.map(({ optionId, title }) => (
            <MenuItem key={optionId} value={optionId}>
              {title[language]}
            </MenuItem>
          ))}
        </FSSelect>
      );
    case QuestionType.BOOLEAN:
      // radio group (boolean yen/no): submit on change
      return (
        <FSRadioGroup
          control={control}
          value={null}
          name={parameters.paramId}
          onBlur={() => {}}
          onChange={() => onSubmitInput()}
        />
      );
    default:
      return null;
  }
}
